import { render, staticRenderFns } from "./CareerMajorList.vue?vue&type=template&id=449b0bee&scoped=true"
import script from "./CareerMajorList.vue?vue&type=script&lang=js"
export * from "./CareerMajorList.vue?vue&type=script&lang=js"
import style0 from "./CareerMajorList.vue?vue&type=style&index=0&id=449b0bee&prod&scoped=true&lang=less"
import style1 from "./CareerMajorList.vue?vue&type=style&index=1&id=449b0bee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b0bee",
  null
  
)

export default component.exports